import { StudentDetailSibling } from './student-detail-sibling.model';
import { StudentDetailEnrollment } from './student-detail-enrollment.model';
import { StudentDetailParentContact } from './student-detail-parent-contact.model';

export class StudentDetail {
    StudentId: string;
    CellPhone: string;
    Gender: string;
    EnrollmentStatus: string;
    EnrollmentType: string;
    EnrollmentEntryDate: string;
    EnrollmentEntryCode: string;
    EmailAddress: string;
    Age: number;
    BirthDate: Date;
    PrimaryCounselor: string;
    PrimaryLanguage: string;
    Locker: string;
    LockerCombination: string;
    Ethnicity: string;
    GraduationPlan: string;
    Bus: string;
    Race: string;
    LivesWith: string;
    StudentStateIdentifier: string;
    HomeRoomCourse: string;
    HomeRoomSection: string;
    HomeRoomRoom: string;
    HomeRoomTeacher: string;
    CurrentLocationCourse: string;
    CurrentLocationSection: string;
    CurrentLocationRoom: string;
    CurrentLocationTeacher: string;
    IEPCaseManager: string;
    ReportCardTranscriptOnHold: string;
    CustodyIssue: string;
    StudentParentContacts: StudentDetailParentContact[];
    StudentEnrollments: StudentDetailEnrollment[];
    StudentSiblings: StudentDetailSibling[];
    ShowStudentLogin: boolean;
    ShowStudentPassword: boolean;
    StudentLogin: string;
    StudentPassword: string;
    EnrollmentDate: string;
    Residency: string;
    Reason: string;
    FTE: number;
    WithdrawReason: string;
    WithdrawDate: string;
    LockerRange: boolean;
    HomeDistrict: string;
    CourtOrderId: number;
    CourtOrderAgainst: string;
    DualEnrolled: string;
    PreviousLastName: string;
    TransportationComment: string;
    PreferedPronouns: string;
}
